import account, { fetchActive } from "../account";
import { addClass, removeClass } from "../utilities";

/**
 * Show/hide public/authed content in the passed `el`
 *
 * This operates on a pretty simple principle:
 * - "public" content will be visible by default
 * - "account" content will be hidden
 * - If the user is not logged in, the "account" content is removed from the DOM
 * - If they are logged in, the "public" content is removed from the DOM and
 *   a `.hide-from-all` class is removed on the "account" content.
 *
 * @param  {Element} el   Element containing both public/authed content
 * @param  {String} options.publicTargetSelector  A CSS selector for the public content
 * @param  {String} options.accountTargetSelector A CSS selector for the authed content
 * @return {Void}
 */
export default function accountToggle(
  el,
  {
    publicTargetSelector,
    accountTargetSelector,
    activeSubscribersOnly,
    removeNodes = true
  }
) {
  const publicTargets = Array.prototype.slice.call(
    el.querySelectorAll(publicTargetSelector)
  );
  const accountTargets = Array.prototype.slice.call(
    el.querySelectorAll(accountTargetSelector)
  );

  const accountCookieValue = account();
  let displayAuthContent = accountCookieValue;

  if (accountCookieValue !== false && activeSubscribersOnly === true) {
    fetchActive().then(active => {
      toggleElems(active, publicTargets, accountTargets, removeNodes);
    });
  } else {
    toggleElems(displayAuthContent, publicTargets, accountTargets, removeNodes);
  }
}

function toggleElems(
  displayAuthContent,
  publicTargets,
  accountTargets,
  removeNodes
) {
  if (displayAuthContent !== false) {
    // Remove public content
    if (removeNodes) {
      publicTargets.forEach(node => node.parentNode.removeChild(node));
    } else {
      publicTargets.forEach(node => addClass(node, "hide-from-all"));
    }
    // Unhide account content
    accountTargets.forEach(node => removeClass(node, "hide-from-all"));
  } else {
    if (removeNodes) {
      accountTargets.forEach(node => {
        node.parentNode.removeChild(node);
      });
    }
  }
}
